// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__eC64r","change-color-on-hover":"BookNowBtn_change-color-on-hover__rVTKX","button":"BookNowBtn_button__4L1CC"};